import moment from 'moment';
import { Badge, Button } from '@themesberg/react-bootstrap';
import React from 'react';
import { Link } from 'react-router-dom';
import { Routes } from '../../../../routes';
import LogoKeno from '../../../../assets/img/logo-keno.png';
import LogoMega from '../../../../assets/img/logo-mega.png';
import LogoPower from '../../../../assets/img/logo-power.png';
import LogoMax3d from '../../../../assets/img/logo-max3d.png';
import LogoMax3dPro from '../../../../assets/img/logo-max3dpro.png';
import LogoLotto535 from '../../../../assets/img/logo-lotto535.png';

const logos = { keno: LogoKeno, mega: LogoMega, power: LogoPower, max3d: LogoMax3d, max3dpro: LogoMax3dPro, lotto535: LogoLotto535 };
const formatMoney = value => Number(value || 0).toLocaleString('vi-VN');

const readNumberRows = ticket => {
  try {
    const detail = JSON.parse(ticket?.detail || '{}');
    return Array.isArray(detail.numberRows) ? detail.numberRows : [];
  } catch (_) {
    return [];
  }
};

export const TableRow = ({ data, visibleColumns, onCheckPress, onPaidPress, onShowDetailPress, onPreviewImage }) => {
  const { ticket = {}, user, netValue, grossValue, tax, fee, isPaid, createdAt } = data;
  const images = Array.isArray(ticket.images) ? ticket.images : [];
  const numberRows = readNumberRows(ticket);
  const periodNumber = ticket.gamePeriodId?.split('-')[1] || ticket.gamePeriodId || '';
  const gameName = ticket.gamePeriod?.game?.name || ticket.gameId || '';

  const cells = {
    actions: (
      <td className="text-center">
        <div className="d-flex flex-wrap gap-1 justify-content-center">
          {!isPaid && <Button size="sm" variant="outline-danger" onClick={() => onCheckPress(ticket.id, ticket.gamePeriodId)}>Kiểm tra vé</Button>}
          <Button size="sm" variant="primary" onClick={() => onShowDetailPress(data)}>Chi tiết</Button>
        </div>
      </td>
    ),
    user: (
      <td>
        <Link
          to={`${Routes.CustomerUser.path}?phone=${encodeURIComponent(user?.phone || '')}&showWallet=1`}
          className="text-decoration-none"
          title="Xem chi tiết người chơi và số dư ví"
        >
          <span className="fw-bold text-dark">{user?.name || 'Chưa cập nhật tên'}</span><br />
          <strong className="text-primary">{user?.phone || ''}</strong>
        </Link>
      </td>
    ),
    ticketId: (
      <td className="text-center">
        <Link
          to={`${Routes.VietlottTicket.path}?ticketId=${encodeURIComponent(ticket.id || '')}&showDetail=1`}
          className="fw-bold text-primary text-decoration-none reward-ticket-id"
          title={ticket.id || ''}
        >
          {ticket.id || ''}
        </Link>
      </td>
    ),
    game: (
      <td className="text-center">
        {logos[ticket.gameId] ? <img src={logos[ticket.gameId]} alt={gameName} className="reward-row-logo" /> : <strong>{gameName}</strong>}
        <div className="mt-1">Kỳ: <strong>{periodNumber}</strong></div>
        {ticket.order != null && <small className="text-muted">STT: {ticket.order}</small>}
      </td>
    ),
    details: (
      <td>
        <small className="text-muted">Mua: {ticket.createdAt ? moment(ticket.createdAt).format('DD/MM/YYYY HH:mm') : '—'}</small><br />
        <small className="text-muted">Hoàn thành: {ticket.doneAt ? moment(ticket.doneAt).format('DD/MM/YYYY HH:mm') : '—'}</small>
        {numberRows.length > 0 && <div className="mt-1 reward-number-rows">{numberRows.map((row, index) => (
          <div key={`${ticket.id}-number-row-${index}`}><strong>{String.fromCharCode(65 + index)}:</strong> {row.numbers?.length ? row.numbers : row.playMethod}</div>
        ))}</div>}
      </td>
    ),
    images: (
      <td className="text-center">
        {images[0] ? (
          <button type="button" className="border-0 bg-transparent p-0" onClick={() => onPreviewImage(`Ảnh vé ${ticket.id}`, images[0])} title="Bấm để xem ảnh lớn">
            <img alt={`Ảnh vé ${ticket.id}`} src={images[0]} className="img-thumbnail reward-ticket-image" />
          </button>
        ) : <span className="text-muted">Chưa có ảnh</span>}
      </td>
    ),
    grossValue: <td className="text-end fw-bold">{formatMoney(grossValue)}</td>,
    tax: <td className="text-end text-danger">{formatMoney(tax)}</td>,
    fee: <td className="text-end text-warning">{formatMoney(fee)}</td>,
    netValue: <td className="text-end fw-bold text-success">{formatMoney(netValue)}</td>,
    status: (
      <td className="text-center">
        {isPaid
          ? <Badge bg="success">Đã trả thưởng</Badge>
          : <Button size="sm" variant="danger" onClick={() => onPaidPress(data)}>Trả thưởng</Button>}
      </td>
    ),
    createdAt: <td className="text-nowrap">{createdAt ? moment(createdAt).format('DD/MM/YYYY HH:mm') : '—'}</td>
  };

  return <tr>{visibleColumns.map(column => React.cloneElement(cells[column], { key: column }))}</tr>;
};
